if (!customElements.get('ui-product-card')) {
  class UIProductCard extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-drawer');

      /** @type {HTMLButtonElement} */
      // @ts-ignore
      this.atcButton = this.querySelector('.product-card__atc-btn');

      /** @type {HTMLInputElement|null} */
      this.planSelect = this.querySelector('ui-select[data-name="plan"]');
    }

    connectedCallback() {
      this.planSelect?.addEventListener(
        'change',
        this.onSubscriptionChange.bind(this),
      );

      this.querySelector('ui-swatches')?.addEventListener(
        'change',
        this.onSwatchChange.bind(this),
      );

      this.atcButton.addEventListener('click', this.onAddToCart.bind(this));
    }

    /**
     * @returns {Product}
     * */
    getProduct() {
      const swatches = this.querySelector('ui-swatches');

      if (swatches?.querySelector('input:checked')) {
        /** @type {Product} */
        // @ts-ignore
        return swatches.value;
      }

      const el = this.querySelector('.product-card__data');
      return JSON.parse(el?.textContent || '');
    }

    getCartItemData() {
      const product = this.getProduct();
      const planType = this.planSelect?.value || null;

      const qty = parseInt(
        // @ts-ignore
        this.querySelector('ui-select[data-name=qty]').value,
      );

      let foundVariant = product.variants[0];
      let sellingPlanId = null;
      let sellingPlan = null;

      if (planType) {
        for (const variant of product.variants) {
          if (variant.title === planType) {
            foundVariant = variant;
            break;
          }
        }

        const group = product.selling_plan_groups[0];

        if ((group && planType === '1 month') || planType === '3 months') {
          const key = 'every ' + planType;
          for (const plan of group.selling_plans) {
            if (plan.name.toLowerCase().includes(key)) {
              sellingPlan = plan;
              sellingPlanId = plan.id;
              break;
            }
          }
        }
      }

      return {
        product,
        qty,
        planType,
        sellingPlanId,
        sellingPlan,
        variant: foundVariant,
      };
    }

    onAddToCart() {
      if (this.atcButton.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.handleErrorMessage('');
      this.disableButton(this.atcButton);

      const { qty, sellingPlanId, variant } = this.getCartItemData();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variant.id.toString());
      formData.append('quantity', qty.toString());
      formData.append('selling_plan', (sellingPlanId || '').toString());
      formData.append('sections_url', window.location.pathname);
      formData.append(
        'sections',
        // @ts-ignore
        this.cart.getSectionsToRender().map(section => section.id),
      );

      // @ts-ignore
      config.body = formData;

      this.disableButton(this.atcButton);

      fetch(`${window.routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          this.enableButton(this.atcButton);

          if (response.status) {
            this.handleErrorMessage(response.message);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });

          // @ts-ignore
          this.cart.renderContents(response);
        })
        .catch(e => {
          console.error('[UI-PRODUCT-CARD:ERROR]', e);
        })
        .finally(() => {
          this.enableButton(this.atcButton);
        });
    }

    /**
     * @param {string} msg
     */
    handleErrorMessage(msg) {
      /** @type {HTMLElement} */
      // @ts-ignore
      const errorEl = this.querySelector('.product-card__errors');

      /** @type {HTMLElement} */
      // @ts-ignore
      const textEl = errorEl?.querySelector('.product-form__error-message');

      if (msg === '') {
        textEl.textContent = msg;
        errorEl?.setAttribute('hidden', '');
        return;
      }

      textEl.textContent = msg;
      errorEl.removeAttribute('hidden');
    }

    /**
     * @param {HTMLButtonElement} button
     */
    disableButton(button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      button.querySelector('.loading__spinner')?.classList.remove('hidden');
    }

    /**
     * @param {HTMLButtonElement} button
     */
    enableButton(button) {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      button.querySelector('.loading__spinner')?.classList.add('hidden');
    }

    onSubscriptionChange() {
      const data = this.getCartItemData();
      let discount = 0;
      let rawPrice = data.variant.price;

      if (data.sellingPlan && data.sellingPlan.price_adjustments[0]) {
        discount = data.sellingPlan.price_adjustments[0].value;
        rawPrice = rawPrice * (1 - discount / 100);
      }

      const updatedPrice = window.Shopify.formatMoney(rawPrice);
      this.querySelectorAll('[data-price]').forEach(el => {
        el.textContent = updatedPrice;
      });
    }

    onSwatchChange() {
      // This is just so the CTA price is updated corrrectly.
      this.onSubscriptionChange();
    }
  }

  customElements.define('ui-product-card', UIProductCard);
}

if (!customElements.get('ui-media-gallery')) {
  class UIMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.firstImg = this.querySelector('.ui-media-gallery__slider-inner img');
      this.firstThumbnail = this.buttons[0]?.querySelector('img');
    }

    connectedCallback() {
      this.buttons.forEach(button => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });

      // Listen for global variant change events
      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        /** @param {any} event */
        (event) => {
          const imageUrl = event?.data?.variant?.featured_image;
          if (imageUrl) this.updateImage(imageUrl);
        }
      );
      
      // Listen to swatch changes (for product cards with swatches)
      const swatches = this.closest('ui-product-card')?.querySelector('ui-swatches');
      if (swatches) {
        swatches.addEventListener('change', (event) => {
          // @ts-ignore - ui-swatches dispatches CustomEvent with detail property
          const detail = event.detail;
          const variant = detail?.variants?.[0];
          const imageUrl = variant?.featured_image || detail?.images?.[0];
          if (imageUrl) this.updateImage(imageUrl);
        });
      }
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    /**
     * @param {string} imageUrl
     */
    updateImage(imageUrl) {
      if (!this.firstImg || !imageUrl) return;

      const baseUrl = (imageUrl.startsWith('http') ? imageUrl : `https:${imageUrl}`).split('?')[0];
      
      // Update main image with srcset for responsive loading
      // @ts-ignore
      this.firstImg.srcset = `${baseUrl}?width=400 400w, ${baseUrl}?width=800 800w, ${baseUrl}?width=1200 1200w`;
      // @ts-ignore
      this.firstImg.src = `${baseUrl}?width=800`;
      
      // Update thumbnail
      if (this.firstThumbnail) {
        // @ts-ignore
        this.firstThumbnail.src = `${baseUrl}?width=100`;
      }
    }

    /**
     * @param {MouseEvent} event
     */
    onButtonClick(event) {
      let imageIndex = 0;

      this.buttons.forEach((x, index) => {
        if (x == event.currentTarget) {
          x.classList.add('is-active');
          imageIndex = index;
        } else {
          x.classList.remove('is-active');
        }
      });

      /** @type {HTMLElement} */
      // @ts-ignore
      const slider = this.querySelector('.ui-media-gallery__slider-inner');

      /** @type {HTMLElement} */
      // @ts-ignore
      const firstImage = slider.firstElementChild;
      const slidewidth = firstImage.clientWidth;
      const newScrollLeft = slidewidth * imageIndex;

      slider.scrollLeft = newScrollLeft;
    }
  }

  customElements.define('ui-media-gallery', UIMediaGallery);
}
